/**
 * check if parsed available time period (schedule) is valid
 */
export default function isValidParsedAvailableTimePeriod(
  value: ParsedAvailableTimePeriod | undefined | null,
) {
  return isValidDateRange(value) && isValidIntervals(value);
}

export function isValidIntervals(
  value: ParsedAvailableTimePeriod | undefined | null,
) {
  // sanity check
  if (!value) {
    return false;
  }

  // check intervals
  const validIntervals = value.intervals.filter((el) => el);
  if (validIntervals.length === 0) {
    return false;
  }
  return validIntervals.every((each) =>
    each === null
      ? true
      : each.length === 0
      ? false
      : each.length > 0 &&
        each.every((el) => !!el && el.start_time && el.end_time),
  );
}

export function isValidDateRange(
  value: ParsedAvailableTimePeriod | undefined | null,
) {
  // sanity check
  if (!value) {
    return false;
  }

  // check start date
  if (!value.start_date) {
    return false;
  }

  // check if end date is required
  if (!value.recurring && !value.end_date) {
    return false;
  }

  return true;
}
